export const parseToNumber = (value: string | undefined): number =>
	value ? Number(value) : Number.NaN;

export const parseToFiniteNumber = (
	value: string | undefined,
): number | undefined => {
	const parsed = parseToNumber(value);
	return Number.isFinite(parsed) ? parsed : undefined;
};

export const isEnumValue = <TEnum extends Record<string, string>>(
	enumObject: TEnum,
	value: unknown,
): value is TEnum[keyof TEnum] =>
	typeof value === "string" &&
	(Object.values(enumObject) as string[]).includes(value);
